import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AutoLogout from "./autologout";
import axios from "axios";
import Swal from "sweetalert2";

function SetMeeting() {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [location, setLocation] = useState("");
  const [objectives, setObjectives] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    // Convert 12-hour time to 24-hour format for submission
    const [hours, minutes] = time.split(":");
    const period = time.slice(-2);
    let hours24 = parseInt(hours, 10);
    if (period === "PM" && hours24 !== 12) {
      hours24 += 12;
    } else if (period === "AM" && hours24 === 12) {
      hours24 = 0;
    }
    const time24 = `${hours24.toString().padStart(2, "0")}:${minutes}`;

    axios
      .post("https://brgytracerappserver.onrender.com/setmeeting", {
        date,
        time: time24,
        location,
        objectives,
      })
      .then((response) => {
        console.log(response.data);
        setDate("");
        setTime("");
        setLocation("");
        setObjectives("");
        if (response.data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "You've set a Meeting",
            showConfirmButton: false,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Something went wrong!",
          text: "System error!!",
        });
      });
  };

  const handleclosed = () => {
    navigate("/adminpage");
  };

  return (
    <div className="meeting-parent parent-height">
      <AutoLogout />
      <div className="meeting-holder wrap">
        <div className="meeting-holder-container">
          <h3>Set a Meeting</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Date:</label>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Time:</label>
              <input
                type="time"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Location:</label>
              <input
                type="text"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                required
              />
            </div>
            <div className="form-group object">
              <label>Objectives:</label>
              <textarea
                value={objectives}
                onChange={(e) => setObjectives(e.target.value)}
                required
              />
            </div>
            <div className="button-holder">
              <button type="submit">Set</button>
              <button className="closebtn" type="button" onClick={handleclosed}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SetMeeting;
